/** @format */
import React from 'react'
import { CustomPageContainer } from 'src/components'
import { _$, Card } from '@king-design/react'
import MonitorAlarmingCard from 'src/containers/MonitorAlarming'
import styled from 'styled-components'
const MonitorAlarming: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={className}>
      <CustomPageContainer title={_$('正在告警')}>
        <Card type="none">
          <MonitorAlarmingCard />
        </Card>
      </CustomPageContainer>
    </div>
  )
}
export default styled(MonitorAlarming)``
